import { createFileRoute } from "@tanstack/react-router";
import { Overview } from "@/features/subscriptions";

const Route = createFileRoute("/_authorized/subscription/overview/")({
  component: () => <Overview />,
});

export { Route };
